import React from "react";
import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import styles from "./NativeInvoiceDrawer.module.scss";

interface Props {
    onCancel: () => void;
    onSave: () => void;
}

// Command bar while the Fields & visibility view replaces the details panel:
// Save keeps the edits; Cancel restores the settings snapshotted when the
// view opened.
export const FieldSettingsCommandBar: React.FC<Props> = ({
    onCancel,
    onSave,
}) => (
    <CommandIsland className={styles.commandBar}>
        <div className={styles.commandBarGroup} />
        <div className={styles.commandBarGroup}>
            <Button variant="secondary" size="md" onClick={onCancel}>
                Cancel
            </Button>
            <WithHotkey
                hotKey="mod+enter"
                hotKeyDisplayPosition="inline"
                hotKeyOptions={{
                    description: "Save field settings",
                    // The view is all form fields, so the shortcut must
                    // keep working while the caret sits in one of them.
                    enableOnFormTags: true,
                    preventDefault: true,
                }}
            >
                {(hotkeyHint) => (
                    <Button variant="primary" size="md" onClick={onSave}>
                        Save
                        {hotkeyHint}
                    </Button>
                )}
            </WithHotkey>
        </div>
    </CommandIsland>
);
